<template>
    <v-app>
        <div id="sicika-app">
            <!-- Navbar (Top Bar) -->
            <Navbar />

            <!-- Main Content -->
            <v-main :style="mainStyle">
                <router-view />
            </v-main>

            <!-- Bottom Navigation Menu -->
            <Navigation />
        </div>
    </v-app>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Navigation from '@/components/Navigation.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute()

const mainStyle = computed(() => {
    const noMarginRoutes = ['Welcome', 'Login', 'Logout', 'Forgot Password', 'Reset Password'];
    return noMarginRoutes.includes(route.name) ? {} : { marginBottom: '160px' };
})
</script>
